import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useRemoveEvChargerMutation } from "../../../../../redux/api/ev-charger/evChargerAPI";
import { AppRoute } from "../../../../../shared/oversight-core/interfaces/app-routes";
import { IPowerConsumerView } from "../../../../../shared/oversight-core/interfaces/entities/power-consumer";
import { IHttpError } from "../../../../../shared/oversight-core/interfaces/http-errror";
import AppDropDown from "../../../../../shared/oversight-core/ui-elements/app-dropdown/app-drop-down";
import MaterialIcon from "../../../../../shared/oversight-core/ui-elements/material-icon/material-icon";
import {
  showErrorMessage,
  showSuccessMessage,
} from "../../../../../shared/oversight-core/utils/toast";
import translate from "../../../../../shared/oversight-core/utils/translate";
import RemoveDeviceModal from "../modals/remove-device-modal/remove-device-modal";
import styles from "./device-card.module.scss";

interface IProps {
  device: IPowerConsumerView;
  onEdit?: (device: IPowerConsumerView) => void;
  onRemoveSuccess?: () => void;
}

const DeviceCard = ({ device, onEdit, onRemoveSuccess }: IProps) => {
  const navigate = useNavigate();
  const [showRemoveModal, setShowRemoveModal] = useState(false);

  const [removeEvCharger, { isLoading: isRemoving }] =
    useRemoveEvChargerMutation();

  const handleCardClick = () => {
    navigate(`${AppRoute.DEVICES}/${device.id}`, {
      state: { pageTitle: device.name ? `Device > ${device.name}` : "Device" },
    });
  };

  const handleRemoveConfirm = () => {
    removeEvCharger({ evChargerId: device.id })
      .unwrap()
      .then(() => {
        showSuccessMessage("Device removed successfully");
        setShowRemoveModal(false);
        if (onRemoveSuccess) onRemoveSuccess();
      })
      .catch((err: IHttpError) => {
        showErrorMessage(err.message || "Failed to remove device");
      });
  };

  return (
    <>
      <div className={styles.deviceCard} onClick={handleCardClick}>
        <Row className="align-items-center justify-content-between">
          <Col>
            <MaterialIcon icon="ev_station" color="var(--dark)" size={25} />
          </Col>
          <Col className="col-auto" onClick={(e) => e.stopPropagation()}>
            <AppDropDown
              icon="more_horiz"
              iconColor="#7483CC"
              buttonSize={25}
              hasDropdownBg={false}
              items={[
                {
                  text: "Edit Device",
                  onClick: () => onEdit?.(device),
                },
                {
                  text: "Remove Device",
                  onClick: () => setShowRemoveModal(true),
                },
              ]}
            />
          </Col>
        </Row>
        <Row className="flex-column my-3">
          <Col className={styles.deviceName}>{device.name || "-"}</Col>
          <Col className={styles.deviceSerial}>{device.serialKey || "-"}</Col>
        </Row>
        <Row className="align-items-center mt-auto">
          <Col className={styles.deviceStatus}>
            {device?.status ? translate(device?.status, "chargingStatus") : ""}
          </Col>
          {/* <Col className="col-auto">
            <MaterialIcon icon="bluetooth" color="#7483CC" size={25} />
          </Col> */}
        </Row>
      </div>
      <RemoveDeviceModal
        show={showRemoveModal}
        deviceName={device.name ?? ""}
        onClose={() => setShowRemoveModal(false)}
        onCancel={() => setShowRemoveModal(false)}
        onConfirm={handleRemoveConfirm}
        isLoading={isRemoving}
      />
    </>
  );
};

export default DeviceCard;
